import React, { useState } from 'react';
import Modal from '../Modal';
import './twitterModal.scss';

import gift from '../../images/gift.svg';
import copyIcon from '../../images/copyIcon.svg';
import { BsTwitter } from 'react-icons/bs';
// import { TwitterShareButton, TwitterIcon } from "react-share";

const tweet =
  'Woohoo! I just tried @Unilend_Finance v2 for permissionless lending and borrowing.This is a new era for #DeFi in #Web3. Try out Unilend v2 and get a chance to win up to $5000 in $UFT. https://unilendv2-testnet.netlify.app/share';

export default function PopupModal() {
  const [modalVisible, setModalVisible] = useState(true);

  const ModalBody = () => {
    return (
      <>
        <div className='modal-wrapper'>
          <h3>Welcome to the new era of DeFi</h3>

          <div className='copy-text-container'>
            <p>{window.location.origin}</p>

            <img src={copyIcon} alt='' />
          </div>

          <div className='info-container'>
            <img src={gift} alt='' />

            <h2>Congratulations!!</h2>
            <p>
              Share your experience of using UniLend v2 and enter a chance to
              win upto $5000.
            </p>
          </div>
          <a
            href={`https://twitter.com/intent/tweet?text=Woohoo! I just tried @UniLend_Finance v2 for permissionless lending and borrowing%0A%0AThis is a new era for ${encodeURIComponent(
              '#Defi in #Web3'
            )}%0A%0ATry out UniLend v2 and get a chance to win up to $5000 in $UFT%0A%0ATestnet: https://testnet.unilend.finance%0A%0AParticipate: https://gleam.io/ABpVU/unilend-v2-launch-5000-in-uft-airdrop
%0A%0A${encodeURIComponent('#unilendV2')}`}
            target='_blank'
          >
            <div className='shareBtn'>
              <BsTwitter color='#fff' fontSize={24} />
              Share
            </div>
          </a>
        </div>
      </>
    );
  };
  return (
    <div>
      <ModalBody />
    </div>
  );
}
